export default {
  OutInvoice: "Output invoice",
  InvoiceDeleted: "Deleted invoice",
  Export: "Export",
  NoDataOutInvoice:
    "If there is no output invoice, please download the output invoice or connect the tax authority to automatically record the output invoice.",
  CanUploadXML: "You can download the invoice file in xml/inv format here.",
  ViewGuid: "View help",
  NoData: "No data",
  NotifyFirstUse: {
    MessageDescription:
      "Features used for output invoices of all supplier's invoices other MISA meInvoice, help automatically update and account",
    MessageDescriptionMISAMeInvoice:
      "issue invoices to automatically synchronize into accounting software and prepare documents for free.",
  },
  Understood: "Got it",
  SelectNumberInvoice: "Invoice {number} selected",
  StatusInvoice: "Invoice status",
  ViewDetailInvoice: "View invoice details",
  ViewInvoice: "View invoice",
  TaxAuthorityCreatedDateOutInvoice: "Submit to taxaxion date",

  // Block transfer to special unit (PBI #599507)
  blockedPopupTitle: 'Cannot transfer invoice',
  blockedTransferToSpecialUnit:
    'The receiving unit <strong>{unitName}</strong> is a third-party invoice verification unit and <span style="color:#f5222d;font-weight:600">does not have the feature</span> to receive outgoing invoices.',
  blockedTransferToSpecialUnitNote: 'Please check the receiving unit again to avoid errors.'
};
